import { render, staticRenderFns } from "./userRegister.vue?vue&type=template&id=008c2846&scoped=true"
import script from "./userRegister.vue?vue&type=script&lang=js"
export * from "./userRegister.vue?vue&type=script&lang=js"
import style0 from "./userRegister.vue?vue&type=style&index=0&id=008c2846&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008c2846",
  null
  
)

export default component.exports